import { t } from 'i18next';
import { AppContext, AppContextPropTypes } from '../../context/AppContext';
import { useContext } from 'react';

const useLogin = () => {
  let myContext: AppContextPropTypes = useContext(AppContext);

  function openForgotPasswordDialog() {
    myContext.setConfirmDialog({
      type: 'forgotPassword',
      open: true,
      title: t('FORGOT_PASSOWRD'),
      message: t('CONTACT_SUPPORT'),
      onYesClick: (event: any, param: string | undefined) => {}
    });
  }

  return { openForgotPasswordDialog };
};

export default useLogin;
